import * as React from 'react';
import { Link } from 'react-router-dom';
import { localization } from 'src/App/shared/localization/localization';
import { Markdown } from 'src/App/shared/localization/markdown-wrapper';

export interface IDtpResultProps {
    success: boolean;
    onClose(): void;
}

interface IDtpResultState {}


class DtpResultComponent extends React.PureComponent<IDtpResultProps,IDtpResultState> {
    constructor(props: IDtpResultProps) {
        super(props);

        this.state = {}
    }

    public render() {
        let message: string;
        let messageStyle: string;
        if (this.props.success) {
            message = localization.uploadLoc.dtpResult.msgSucess;
            // messageStyle = 'status-text-success';
            messageStyle = '';
        } else {
            message = localization.uploadLoc.dtpResult.msgFail;
            messageStyle = 'status-text-fail';
        }

        return (
            <div className="dtp-result-root">
                <div className="d-flex justify-content-center">
                    <div className="row-message">
                        <span className={messageStyle}>
                            <Markdown text={message} />
                        </span>
                    </div>
                </div>
                <div className="d-flex justify-content-center">
                    <div className="row-buttons">
                        <button className="main-button primary-style" onClick={() => this.props.onClose()}>
                            <Markdown text={localization.uploadLoc.dtpResult.backToGallery} />
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export const DtpResult = (props: IDtpResultProps) => <DtpResultComponent {...props} />



// WEBPACK FOOTER //
// ./src/App/logo-app/logo-upload/dtp-result.component.tsx